import React, { useEffect, useRef, useState } from 'react'
import { FaBed, FaChevronDown, FaMinus, FaPlus, FaRegCalendarAlt, FaRegPlusSquare, FaRegTimesCircle, FaSearch, FaUsers } from "react-icons/fa";
import { Row, Col, Select, DatePicker, Card, Divider, Button, Input, Popover, Form, Drawer } from 'antd';
import { useNavigate } from 'react-router-dom';
import "../hotel.scss"
import dayjs from 'dayjs';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { fetchHotelList } from '../../../redux/hotel/hotelListSlice';
import { popularHotelCities } from '../../../utils/Constants';


const SearchBarHotel = () => {
  const [open, setOpen] = useState(false);
  const dateFormat = 'MMM DD, YYYY';
  // const currentFormattedDate = dayjs().format(dateFormat);
  // const nextDate = dayjs().add(1, 'day').format(dateFormat);
  // const currentDate = dayjs().format('YYYY-MM-DD');
  // const nextDateFormate = dayjs().add(1, 'day').format('YYYY-MM-DD');
  const popoverRef = useRef(null);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const dispatch = useDispatch();
  const hotelList = useSelector(state => state.hotel.hotelList);
  const error = useSelector(state => state.hotel.error);
  const [searchTerm, setSearchTerm] = useState('');
  const [showSearchList, setShowSearchList] = useState(false);
  const [isCitySelected, setIsCitySelected] = useState(false);
  const [topCityData, setTopCityData] = useState(true);

  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
  };

  const delayedSearch = debounce((term) => {
    dispatch(fetchHotelList(term));
    setShowSearchList(true);
  }, 1000);

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
    delayedSearch(event.target.value);
    setTopCityData(false)
    if (event.target.value === "") {
      setTopCityData(true)
    }
  };

  const handleSearchButtonClick = () => {
    setShowSearchList(true);
    setTopCityData(true)
    delayedSearch(searchTerm);
  };

  const handleSelectHotel = (hotel) => {
    localStorage.setItem("hotelSearchKey", JSON.stringify({
      'id': hotel?.id,
      'name': hotel?.name,
      'cityId': hotel?.tboCityId,
      'state': hotel?.state,
      'countryName': hotel?.countryName,
      'countryId': hotel?.countryId,
      'countryCode': hotel?.tboCountryCode,
      'source': hotel?.source,
      'tripjack_city_id': hotel?.tripjack_city_id,
    }));
    setSelectedHotel(hotel);
    setIsCitySelected(true);
    setShowSearchList(false);

  };


  const [rooms, setRooms] = useState([
    { numberOfAdults: 1, numberOfChild: 0, childAge: [] }
  ]);

  const [toTalSelectRooms, setToTalSelectRooms] = useState(null);

  const addRoom = (e) => {
    setOpen(true);
    e.stopPropagation();
    if (rooms.length < 5) {
      setRooms([...rooms, { numberOfAdults: 1, numberOfChild: 0, childAge: [] }]);
    }
  };

  const removeRoom = (index, e) => {
    e.stopPropagation();
    if (rooms.length > 1) {
      setRooms(rooms.filter((_, i) => i !== index));
    }
  };

  const addAdults = (index) => {
    const updatedRooms = [...rooms];
    updatedRooms[index].numberOfAdults += 1;
    setRooms(updatedRooms);
  };

  const removeAdults = (index) => {
    const updatedRooms = [...rooms];
    if (updatedRooms[index].numberOfAdults > 1) {
      updatedRooms[index].numberOfAdults -= 1;
    }
    setRooms(updatedRooms);
  };

  const addChildren = (index) => {
    const updatedRooms = [...rooms];
    if (updatedRooms[index].numberOfChild < 3) {
      updatedRooms[index].numberOfChild += 1;
      updatedRooms[index].childAge.push(null);
    }
    setRooms(updatedRooms);
  };

  const removeChildren = (index) => {
    const updatedRooms = [...rooms];
    if (updatedRooms[index].numberOfChild > 0) {
      updatedRooms[index].numberOfChild -= 1;
      updatedRooms[index].childAge.pop();
    }
    setRooms(updatedRooms);
  };

  const onSelectChildAge = (value, roomIndex, childIndex) => {
    const updatedRooms = [...rooms];
    updatedRooms[roomIndex].childAge[childIndex] = value;
    setRooms(updatedRooms);
  };

  const applyChanges = () => {
    const roomInfo = rooms.map(room => ({
      numberOfAdults: room.numberOfAdults,
      numberOfChild: room.numberOfChild,
      childAge: room.childAge.filter(age => age !== null),
    }));
    setToTalSelectRooms(roomInfo)
    setOpen(false)
  };

  const totalAdults = rooms.reduce((total, room) => total + room.numberOfAdults, 0);
  const totalChildren = rooms.reduce((total, room) => total + room.numberOfChild, 0);
  const totalRooms = rooms.length;

  const content = (
    <>
      <Form className='popup-form hotel-room-select' style={{ width: '100%', minWidth: '320px' }} onFinish={applyChanges}>
        <div className='popup-inner'>

          {rooms?.map((room, index) => (
            <div key={index}>
              <div className='d-flex align-items-center justify-content-between mt-2 mb-3'>
                <h3><FaBed /> Room {index + 1}</h3>
                {rooms.length > 1 && (
                  <button
                    onClick={(e) => removeRoom(index, e)}
                    className='btn px-2 border text-primary py-1'
                    aria-label="Remove"
                  >
                    Remove
                  </button>
                )}
              </div>

              <div className='d-md-flex align-items-center justify-content-between border-bottom'>
                <div className='select-adult mb-2 pe-md-3 me-md-3'>
                  <h6>Adults</h6>
                  <span className='selection'>
                    <Button className='me-3' onClick={() => removeAdults(index)} aria-label="remove adults"><FaMinus /></Button>
                    <span className='me-3'>{rooms[index].numberOfAdults}</span>
                    <Button onClick={() => addAdults(index)} disabled={rooms[index].numberOfAdults >= 3} aria-label="add adults"><FaPlus /></Button>
                  </span>
                </div>

                <div className='select-child mb-2'>
                  <h6>Children</h6>
                  <span className='selection'>
                    <Button className='me-3' onClick={() => removeChildren(index)} aria-label="remove child"><FaMinus /></Button>
                    <span className='me-3'>{rooms[index].numberOfChild}</span>
                    <Button onClick={() => addChildren(index)} disabled={rooms[index].numberOfChild >= 3} aria-label="add child">
                      <FaPlus />
                    </Button>
                  </span>
                </div>
              </div>

              <Row gutter={16}>
                {rooms[index].childAge.map((_, childIndex) => (
                  <Col xs={12} md={8} className='w-100'>
                    <div key={childIndex}>
                      <div className='select-amount'>
                        <Form.Item
                          name={`childAge-${index}-${childIndex}`}
                          rules={[
                            {
                              required: true,
                              message: 'Please select age',
                            },
                          ]}
                        >
                          <Select
                            onChange={(value) => onSelectChildAge(value, index, childIndex)}
                            defaultValue={null}
                            placeholder="Select age"
                            style={{ width: '100%' }}
                            className='my-2'
                          >
                            {[...Array(12)].map((_, age) => (
                              <Option key={age} value={age + 1}>
                                {age + 1} years old
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          ))}

          {rooms?.length === 5 && <p>Maximum 5 rooms can be added</p>}
          <div
            onClick={addRoom}
            disabled={rooms.length >= 5}
            className='d-flex align-items-center border-0 bg-white text-right my-2'
            style={{ cursor: "pointer" }}
          >
            <FaRegPlusSquare className='me-1' style={{ fontSize: '20px' }} /> Add Room
          </div>


          <Button htmlType='submit' className='w-100 btn btn-primary' aria-label="done" >
            Done
          </Button>
        </div>
      </Form>
    </>
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setShowSearchList(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const navigate = useNavigate()
  const today = dayjs().add(1, "day").format(dateFormat);
  const nextDay = dayjs().add(2, "day").format(dateFormat);
  const [departureDate, setDepartureDate] = useState(today);
  const [returnDate, setReturnDate] = useState(nextDay);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [isDatePickerOpenReturn, setIsDatePickerOpenReturn] = useState(false);
  const datePickerRef = useRef(null);
  const datePickerRefReturn = useRef(null);
  const [isDatePickerOpen1, setIsDatePickerOpen1] = useState('');

  const fetchAllHotalRooms = () => {
    localStorage.setItem('startDate', JSON.stringify(departureDate));
    localStorage.setItem('endDate', JSON.stringify(returnDate));
    const storedStartDate = JSON.parse(localStorage.getItem("startDate"));
    const storedEndDate = JSON.parse(localStorage.getItem("endDate"));

    const start_date = moment(storedStartDate);
    const end_date = moment(storedEndDate);
    const diff = start_date.isValid() && end_date.isValid()
      ? end_date.diff(start_date, "days")
      : 0;

    localStorage.setItem("night", JSON.stringify(diff));
    localStorage.setItem('roomInfo', JSON.stringify(toTalSelectRooms));
    const formattedCity = selectedHotel?.name?.toLowerCase().replace(/\s+/g, '-');
    const formattedCountry = selectedHotel?.countryName?.toLowerCase().replace(/\s+/g, '-');
    const urlIdDynamic = `hotels-in-${formattedCity}`;
    let resultUrl = `/hotels-${formattedCountry}/${urlIdDynamic}`
    navigate(resultUrl)
  };


  const disabledPastDate = (current) => {
    return current && current < moment().startOf("day");
  };

  const disabledReturnDate = (current) => {
    return (
      current &&
      (current < moment().startOf("day") || current < dayjs(departureDate).endOf("day"))
    );
  };

  const onChangeDeparture = (date, dateString) => {
    setDepartureDate(dateString);
    if (!returnDate || dayjs(dateString).isAfter(dayjs(returnDate))) {
      const updatedReturnDate = dayjs(dateString).add(1, "day").format(dateFormat);
      setReturnDate(updatedReturnDate);
    }
    setTimeout(() => {
      setIsDatePickerOpen(false);
      setIsDatePickerOpenReturn(true);
    }, 100);
  };

  const onChangeReturn = (date, dateString) => {
    setReturnDate(dateString);
    setIsDatePickerOpenReturn(false);
  };

  const handleClickOutside = (event) => {
    try {
      const isOutsideDatePicker =
        datePickerRef.current instanceof HTMLElement &&
        !datePickerRef.current.contains(event.target);
      const isOutsideDatePickerReturn =
        datePickerRefReturn.current instanceof HTMLElement &&
        !datePickerRefReturn.current.contains(event.target);
      if (isOutsideDatePicker && isOutsideDatePickerReturn) {
        setIsDatePickerOpen(false);
        setIsDatePickerOpenReturn(false);
      }
    } catch (error) {
      console.error("Error in handleClickOutside:", error);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  useEffect(() => {
    setIsDatePickerOpen(false);
    setIsDatePickerOpenReturn(false);
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDatePickerOpen1, returnDate]);

  const inputRef = useRef(null);

  useEffect(() => {
    if (showSearchList && inputRef.current) {
      inputRef.current.focus();
    }
  }, [showSearchList]);

  const handleDivClick = () => {
    setIsDatePickerOpen(true);
    setIsDatePickerOpenReturn(false);
  };

  const handleDivClickReturn = () => {
    setIsDatePickerOpenReturn(true);
    setIsDatePickerOpen(false);
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isReturnDrawerOpen, setIsReturnDrawerOpen] = useState(false);
  const todayCurrent = moment();
  const generateCalendarRetrun = () => {
    const calendar = [];
    const endOfYear = todayCurrent.clone().add(1, "year").endOf("year");
    let current = todayCurrent.clone().startOf("month");

    while (current.isBefore(endOfYear, "month")) {
      const daysInMonth = current.daysInMonth();
      const startDay = current.clone().startOf("month").day();

      const monthData = {
        month: current.format("MMMM YYYY"),
        days: [],
      };

      for (let i = 0; i < startDay; i++) {
        monthData.days.push(null);
      }

      for (let day = 1; day <= daysInMonth; day++) {
        const date = current.clone().date(day);
        monthData.days.push(date);
      }

      calendar.push(monthData);
      current.add(1, "month");
    }

    return calendar;
  };
  const calendarData = generateCalendarRetrun();

  const handleDateSelect = (date) => {
    if (!date || date.isBefore(todayCurrent, "day")) return;
    setDepartureDate(date.format("YYYY-MM-DD"));
    setIsDrawerOpen(false);
    setReturnDate(date.format("YYYY-MM-DD"))
    setIsReturnDrawerOpen(true)
  };


  const handleReturnDateSelect = (date) => {
    if (!date || !departureDate || date.isBefore(moment(departureDate, "YYYY-MM-DD"), "day")) {
      return;
    }
    setReturnDate(date.format("YYYY-MM-DD"));
    setIsReturnDrawerOpen(false);
  };

  const filteredCalendarData = calendarData.filter((month) => {
    const firstDate = month.days.find((date) => date);
    return firstDate && firstDate.isSameOrAfter(todayCurrent, "month");
  });

  const filteredReturnCalendarData = calendarData.filter((month) => {
    const firstDate = month.days.find((date) => date);
    const departureMoment = departureDate ? moment(departureDate, "YYYY-MM-DD") : null;
    return (
      firstDate &&
      departureMoment &&
      firstDate.isSameOrAfter(todayCurrent, "month")
    );
  });

  const [placement] = useState('bottomLeft');

  const formatCheckinDate = (dateString) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    const date = new Date(dateString);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = String(date.getFullYear()).slice(2);
    const weekday = weekdays[date.getDay()];

    return {
      day,
      month,
      year,
      weekday
    };
  };

  const checkin = formatCheckinDate(departureDate);
  const checkout = formatCheckinDate(returnDate);

  const { day, month, year, weekday } = checkin;
  const { day: dayReturn, month: monthReturn, year: yearReturn, weekday: weekdayReturn } = checkout;

  return (
    <>
      <section className='hotel_search'>
        <svg className='bg_svg' xmlns="https://www.w3.org/2000/svg" width="513" height="501" viewBox="0 0 713 701">
          <mask id='mask1' mask-type="alpha">
            <path d="M22.5284 206.074C-17.3353 138.188 5.91852 53.0191 22.5284 -7.5H718.5V110L718.662 700.917C641.04 701.903 467.935 694.503 396.497 657.007C307.198 610.138 347.654 534.653 273.649 495.184C199.645 455.715 242.074 351.616 216.42 312.147C190.765 272.678 72.3579 290.933 22.5284 206.074Z" fill="#FFF1DA" />
          </mask>
          <g mask='url(#mask1)'>
            <path d="M22.5284 206.074C-17.3353 138.188 5.91852 53.0191 22.5284 -7.5H718.5V110L718.662 700.917C641.04 701.903 467.935 694.503 396.497 657.007C307.198 610.138 347.654 534.653 273.649 495.184C199.645 455.715 242.074 351.616 216.42 312.147C190.765 272.678 72.3579 290.933 22.5284 206.074Z" fill="#FFF1DA" />
            <image className='newImage' href="/images/HotelBanner.avif" alt="Banner Background" loading="eager" fetchpriority="high" decoding="async" height="580" style={{ objectFit: 'cover' }} />
          </g>
        </svg>
        <div className='container'>

          <Row gutter={16} className='w-100 justify-content-center m-0 d-block'>
            <Card>
              <div className='justify-content-between parveen'>
                <h2 className='text-primary'>Where is your Next Dream Place?</h2>
                <p>Find exclusive Genius rewards in every corner of the world!</p>
              </div>

              <Divider className='mt-2' />

              <Row gutter={16} className='gap-2 gap-md-0'>

                <Col lg={8} md={24} xs={24} className='w-100 from_to_box pe-md-1 mb-lg-0 mb-md-2' >
                  <div className='hotel_destination' onClick={handleSearchButtonClick}>
                    <label>
                      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="16px" height="16px" viewBox="0 0 32 32" version="1.1" fill="#999999">
                        <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                        <g id="SVGRepo_iconCarrier"> <defs> </defs> <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" sketch:type="MSPage"> <g id="Icon-Set" sketch:type="MSLayerGroup" transform="translate(-104.000000, -411.000000)" fill="#999999"> <path d="M116,426 C114.343,426 113,424.657 113,423 C113,421.343 114.343,420 116,420 C117.657,420 119,421.343 119,423 C119,424.657 117.657,426 116,426 L116,426 Z M116,418 C113.239,418 111,420.238 111,423 C111,425.762 113.239,428 116,428 C118.761,428 121,425.762 121,423 C121,420.238 118.761,418 116,418 L116,418 Z M116,440 C114.337,440.009 106,427.181 106,423 C106,417.478 110.477,413 116,413 C121.523,413 126,417.478 126,423 C126,427.125 117.637,440.009 116,440 L116,440 Z M116,411 C109.373,411 104,416.373 104,423 C104,428.018 114.005,443.011 116,443 C117.964,443.011 128,427.95 128,423 C128,416.373 122.627,411 116,411 L116,411 Z" id="location" sketch:type="MSShapeGroup"> </path> </g> </g> </g>
                      </svg>
                      Where </label>
                    <button className='hotel_from-search-btn'
                      onClick={handleSearchButtonClick}
                      aria-label="Select City"
                    >
                      <span className='Hotel-select-title'>{selectedHotel ? selectedHotel?.name.charAt(0) + selectedHotel?.name.slice(1).toLowerCase() : 'Select City'}</span>
                      <span className='Hotel-select-subtitle'> {selectedHotel ? selectedHotel.countryName.charAt(0) + selectedHotel.countryName.slice(1).toLowerCase() : 'Country'}</span>
                    </button>
                  </div>

                  {showSearchList && (
                    <div ref={popoverRef} className='search-list-container'>
                      <Input ref={inputRef} style={{ height: "48px" }} size="large" className='mb-2' placeholder="Where do you want to stay ..." value={searchTerm} onChange={handleInputChange} prefix={<FaSearch className='mx-1' />} />

                      {topCityData ? (
                        <ul className="search-list my-2">
                          <span className="mx23 text-uppercase">Popular Cities</span>
                          {popularHotelCities?.map((hotel, index) => (
                            <li
                              key={index}
                              onClick={() => handleSelectHotel(hotel)}
                              className="hotel-list-item mt-2"
                            >
                              <div className="d-flex align-items-center">
                                <span className="me-2 location-icon">
                                  <svg
                                    width="1em"
                                    height="1em"
                                    viewBox="-1.5 0 15 15"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill={hotel.countryName.toLowerCase() == 'india' ? '#20926d' : '#000000'}
                                  >
                                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                    <g id="SVGRepo_iconCarrier">
                                      <path
                                        fill={hotel.countryName.toLowerCase() == 'india' ? '#20926d' : '#000000'}
                                        fillRule="evenodd"
                                        d="M574,120 C575.324428,120 580,114.054994 580,110.833333 C580,107.611672 577.313708,105 574,105 C570.686292,105 568,107.611672 568,110.833333 C568,114.054994 572.675572,120 574,120 Z M574,113.333333 C575.420161,113.333333 576.571429,112.214045 576.571429,110.833333 C576.571429,109.452621 575.420161,108.333333 574,108.333333 C572.579839,108.333333 571.428571,109.452621 571.428571,110.833333 C571.428571,112.214045 572.579839,113.333333 574,113.333333 Z"
                                        transform="translate(-568 -105)"
                                      ></path>
                                    </g>
                                  </svg>
                               </span>

                                <div className="d-flex justify-content-between align-items-center w-100">
                                  <span className={`airportTitle d-block ${hotel.countryName.toLowerCase()}`}>
                                    {hotel.name.charAt(0).toUpperCase() +
                                      hotel.name.slice(1).toLowerCase()}
                                  </span>
                                  <span className={`airportSubTitle d-block ${hotel.countryName.toLowerCase()}`}>
                                    {hotel.countryName.charAt(0).toUpperCase() +
                                      hotel.countryName.slice(1).toLowerCase()}
                                  </span>
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <ul className="search-list my-2">
                          <span className="mx23 text-uppercase">City, Hotel name or Location</span>
                          {hotelList?.map((hotel, index) => (
                            <li
                              key={index}
                              onClick={() => handleSelectHotel(hotel)}
                              className="hotel-list-item mt-2"
                            >
                              {hotel?.source == 'city' && (
                                <div className="d-flex align-items-center">
                                  <span className="me-2 location-icon">
                                    <svg width="1em" height="1em" viewBox="-1.5 0 15 15" xmlns="http://www.w3.org/2000/svg" fill={hotel.countryName.toLowerCase() == 'india' ? '#20926d' : '#000000'}><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill={hotel.countryName.toLowerCase() == 'india' ? '#20926d' : '#000000'} fillRule="evenodd" d="M574,120 C575.324428,120 580,114.054994 580,110.833333 C580,107.611672 577.313708,105 574,105 C570.686292,105 568,107.611672 568,110.833333 C568,114.054994 572.675572,120 574,120 Z M574,113.333333 C575.420161,113.333333 576.571429,112.214045 576.571429,110.833333 C576.571429,109.452621 575.420161,108.333333 574,108.333333 C572.579839,108.333333 571.428571,109.452621 571.428571,110.833333 C571.428571,112.214045 572.579839,113.333333 574,113.333333 Z" transform="translate(-568 -105)"></path> </g></svg>
                                  </span>
                                  <div className="d-flex justify-content-between align-items-center w-100">
                                    <span className={`airportTitle d-block ${hotel.countryName.toLowerCase()}`}>
                                      {hotel?.name.charAt(0).toUpperCase() +
                                        hotel?.name.slice(1).toLowerCase()}
                                    </span>
                                    <span className={`airportSubTitle d-block ${hotel.countryName.toLowerCase()}`}>
                                      {hotel?.countryName.charAt(0).toUpperCase() +
                                        hotel?.countryName.slice(1).toLowerCase()}
                                    </span>
                                  </div>
                                </div>
                              )}
                              {hotel?.source == 'hotel' && (
                                <div className="flight-details">
                                  <span className="icon">
                                    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" transform="matrix(-1, 0, 0, 1, 0, 0)rotate(0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier">  <g id="Layer_Grid"></g> <g id="Layer_2"> <path d="M12.1,4.6L5.4,2.1C5,1.9,4.7,2,4.4,2.2C4.2,2.4,4,2.7,4,3v16c0,1.7,1.3,3,3,3h6h2h2c1.7,0,3-1.3,3-3v-4c0-1.7-1.3-3-3-3h-3 V7.4C14,6.1,13.2,5,12.1,4.6z M12,13v7h-2v-2.3c0-0.4-0.3-0.8-0.8-0.8H8.8C8.3,17,8,17.3,8,17.8V20H7c-0.6,0-1-0.4-1-1V4.4l5.4,2 C11.7,6.6,12,7,12,7.4V13z M17,14c0.6,0,1,0.4,1,1v4c0,0.6-0.4,1-1,1v-1.3c0-0.4-0.3-0.8-0.8-0.8h-0.5c-0.4,0-0.8,0.3-0.8,0.8V20 h-1v-6H17z"></path> <rect height="1" width="1" x="7" y="7"></rect> <rect height="1" width="1" x="8" y="12"></rect> <rect height="1" width="1" x="9" y="9"></rect> <rect height="1" width="1" x="10" y="14"></rect> <rect height="1" width="1" x="16" y="15"></rect> </g> </g></svg>
                                  </span>
                                  <div className="flight-info">
                                    <span className="airportTitle">
                                      {hotel?.name &&
                                        (hotel.name.length > 30
                                          ? hotel.name.slice(0, 30).charAt(0).toUpperCase() +
                                          hotel.name.slice(1, 30).toLowerCase() +
                                          '...'
                                          : hotel.name.charAt(0).toUpperCase() + hotel.name.slice(1).toLowerCase())}
                                    </span><br />
                                    <span className="airportSubTitle">Hotel in {hotel?.name && (hotel.cityName.charAt(0).toUpperCase() + hotel.cityName.slice(1).toLowerCase())},
                                      {hotel?.name && ((hotel.state.charAt(0).toUpperCase() || hotel.countryName.charAt(0).toUpperCase()) + (hotel.state.slice(1).toLowerCase() || hotel.countryName.slice(1).toLowerCase()))}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  )}

                </Col>

                <Col lg={8} md={12} xs={24} className=''>
                  <Row gutter={16} className=''>

                    <Col span={12} className="pe-1 d-none d-md-block" onClick={handleDivClick} >
                      <div className='checkin'>
                        <label><FaRegCalendarAlt /> Check In</label>
                        <DatePicker
                          ref={datePickerRef}
                          variant="bordered"
                          onChange={onChangeDeparture}
                          open={isDatePickerOpen}
                          value={departureDate ? dayjs(departureDate, dateFormat) : null}
                          format={dateFormat}
                          allowClear={false}
                          showNow={false}
                          disabledDate={disabledPastDate}
                          onOpenChange={(status) => setIsDatePickerOpen(status)}
                          placement={placement}
                        />
                        <span>{dayjs(departureDate).format("dddd")}</span>
                      </div>
                    </Col>

                    <Col span={12} className="ps-1 d-none d-md-block" onClick={handleDivClickReturn} >
                      <div className='checkout'>
                        <label><FaRegCalendarAlt className='' /> Check Out</label>
                        <DatePicker
                          ref={datePickerRefReturn}
                          variant="bordered"
                          onChange={onChangeReturn}
                          open={isDatePickerOpenReturn}
                          value={returnDate ? dayjs(returnDate, dateFormat) : null}
                          format={dateFormat}
                          allowClear={false}
                          showNow={false}
                          disabledDate={disabledReturnDate}
                          onOpenChange={(status) => setIsDatePickerOpenReturn(status)}
                          placement={placement}
                        />
                        <span>{dayjs(returnDate).format("dddd")}</span>
                      </div>
                    </Col>


                    {/* mobile View */}
                    {/* Departure Date Picker */}
                    <Col span={12} className="pe-md-1 ps-md-1 w-100 pe-1 d-md-none">
                      <div
                        onClick={() => setIsDrawerOpen(true)}
                        className="open-calendar-btn select-date"
                      >
                        <div className="checkin-card">
                          <div className="icon-section">
                            <FaRegCalendarAlt fontSize={25} />
                          </div>
                          <div className="date-details">
                            <label className="label">Check-in</label>
                            <div className="date-main">
                              <span className="day">{day}</span>
                              <div className="month-year">
                                <span>{month} '{year}</span>
                                <span className="weekday">{weekday}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <Drawer
                        title="Check In "
                        placement="bottom"
                        onClose={() => setIsDrawerOpen(false)}
                        open={isDrawerOpen}
                        height="86vh"
                        className="calendar-drawer"
                        closeIcon={null}
                        styles={{ header: { textAlign: "right" } }}
                        extra={
                          <div
                            type="text"
                            onClick={() => setIsDrawerOpen(false)}
                            className="custom-close-icon mt-2"
                            style={{ color: "#fff" }}
                          >
                            <FaRegTimesCircle fontSize={25} />
                          </div>
                        }
                      >
                        <div className="calendar-container">
                          {filteredCalendarData.map((month, index) => (
                            <div key={index} className="month-section">
                              <h4 className="month-title">{month.month}</h4>
                              <div className="day-labels">
                                {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                                  <div key={day} className="day-label">
                                    {day}
                                  </div>
                                ))}
                              </div>
                              <div className="dates-grid">
                                {month.days.map((date, idx) => (
                                  <div
                                    key={idx}
                                    className={`date-cell ${!date
                                      ? "empty"
                                      : date.isBefore(todayCurrent, "day")
                                        ? "disabled"
                                        : date.isSame(moment(departureDate), "day")
                                          ? "selected"
                                          : ""
                                      }`}
                                    onClick={() => handleDateSelect(date)}
                                  >
                                    {date ? (
                                      <>
                                        <div className="date">{date.format("D")}</div>
                                      </>
                                    ) : null}
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      </Drawer>

                    </Col>

                    <Col span={12} className="pe-md-1 ps-md-1 ps-1 w-100 d-md-none">
                      <div
                        onClick={() => setIsReturnDrawerOpen(true)}
                        className="select-date"
                      >

                        <div className="checkin-card">
                          <div className="icon-section">
                            <FaRegCalendarAlt fontSize={25} />
                          </div>
                          <div className="date-details">
                            <label className="label">Check Out</label>
                            <div className="date-main">
                              <span className="day">{dayReturn}</span>
                              <div className="month-year">
                                <span>{monthReturn} '{yearReturn}</span>
                                <span className="weekday">{weekdayReturn}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <Drawer
                        title="Check Out"
                        placement="bottom"
                        onClose={() => setIsReturnDrawerOpen(false)}
                        open={isReturnDrawerOpen}
                        height="85vh"
                        className="calendar-drawer"
                        closeIcon={null}
                        styles={{ header: { textAlign: "right" } }}
                        extra={
                          <div
                            onClick={() => setIsReturnDrawerOpen(false)}
                            className="custom-close-icon mt-2"
                            style={{ color: '#fff' }}
                          >
                            <FaRegTimesCircle fontSize={25} />
                          </div>
                        }
                      >
                        <div className="calendar-container">
                          {filteredReturnCalendarData.map((month, index) => (
                            <div key={index} className="month-section">
                              <h4 className="month-title">{month.month}</h4>
                              <div className="day-labels">
                                {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
                                  <div key={day} className="day-label">{day}</div>
                                ))}
                              </div>
                              <div className="dates-grid">
                                {month.days.map((date, idx) => (
                                  <div
                                    key={idx}
                                    className={`date-cell ${!date
                                      ? "empty"
                                      : date.isBefore(moment(departureDate), "day")
                                        ? "disabled"
                                        : date.isSame(moment(returnDate), "day")
                                          ? "selected"
                                          : ""
                                      }`}
                                    onClick={() => handleReturnDateSelect(date)}
                                  >
                                    <div className="date">{date?.format('D')}</div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      </Drawer>
                    </Col>


                  </Row>
                </Col>

                <Col lg={8} md={12} xs={24} className="w-100 ps-md-1">
                  <Popover
                    content={content}
                    placement="bottom"
                    trigger="click"
                    zIndexPopup="1030"
                    open={open}
                    onOpenChange={() => setOpen(true)}
                  >
                    <div className='flight_from flight_from2'>
                      <span className='from-title'><FaUsers />  Room | Adult | Child  </span>

                      <div className="select-hotel">
                        {totalAdults} {totalAdults === 1 ? "Adult" : "Adults"}

                        {totalChildren !== 0 && (
                          <>
                            , {""} {totalChildren} {totalChildren === 1 ? "Child" : "Children"}
                          </>
                        )}
                        <FaChevronDown className='d-none' />
                      </div>
                      <span>
                        {totalRooms} {totalRooms === 1 ? "Room" : "Rooms"}
                      </span>

                    </div>
                  </Popover>
                </Col>

              </Row >
              <div className="text-center">
                <Button disabled={!isCitySelected} onClick={fetchAllHotalRooms} className="ant-btn css-dev-only-do-not-override-1xg9z9n ant-btn-primary" aria-label="Search"><span>Search</span></Button></div>
            </Card >
          </Row >
        </div>
      </section>

    </>
  )
}

export default SearchBarHotel